/**
 * Parses user input accepting both `,` and `.` as the decimal separator, so a
 * value typed in any language (or pasted from another source) is understood.
 */
export const parseDecimal = (value: string): number | null => {
  const normalized = value.trim().replace(/\s/g, '').replace(',', '.');
  if (!normalized) {
    return null;
  }

  const parsed = Number(normalized);
  if (!Number.isFinite(parsed)) {
    return null;
  }
  return parsed;
};

/**
 * Reads a numeric form value that may hold a typed string or a number (e.g.
 * set programmatically). Returns null when the field is empty or not numeric.
 */
export const parseNumericInput = (value: unknown): number | null => {
  if (typeof value === 'number') {
    if (Number.isFinite(value)) {
      return value;
    }
    return null;
  }
  if (typeof value === 'string') {
    return parseDecimal(value);
  }
  return null;
};
